import React from "react";
import { motion } from "framer-motion";
import CatThumbnail from "./CatThumbnail";
import thumbnailAll from "./../images/thumbnail_cat.jpg";
import thumbnailSculpture from "./../images/thumbnail_sculpture.jpg";
import thumbnailVisualArts from "./../images/thumbnail_visual_arts.jpg";
import thumbnailVideo from "./../images/thumbnail_book.jpg";
import thumbnailStreetView from "./../images/thumbnail_streetview.jpg";
import thumbnailTextile from "./../images/thumbnail_textile.jpg";



class Intro extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //count: 0,
    };
    this.i18n = props.i18n
  }

  render() {
    const { pickData } = this.props;
    return (
      <div className="intro-container w-100 h-100 flex items-center flex-column bg-custom-beige overflow-x-hidden">
        <motion.div
          className="flex flex-column items-center mt-auto mb-auto"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ ease: 'easeOut', duration: 0.8 }}
        >
          <div className="w-100 tc mb2">
            <h1>{this.i18n.title}</h1>
            <h3>{this.i18n.tagline_in_game}</h3>
            <p>{this.i18n.pick_your_category}</p>
          </div>
          <div className="flex w-100-ns w-80 category-container flex-wrap flex-nowrap-ns items-center justify-center">
            <CatThumbnail
              title={this.i18n.visual_arts}
              keyword="painting"
              pickData={pickData}
              src={thumbnailVisualArts}
            />
            <CatThumbnail
              title={this.i18n.sculpture}
              keyword="sculpture"
              pickData={pickData}
              src={thumbnailSculpture}
            />
            <CatThumbnail
              title={this.i18n.streetview}
              keyword="streetview"
              pickData={pickData}
              src={thumbnailStreetView}
            />
            <CatThumbnail
              title={this.i18n.textile}
              keyword="textile"
              pickData={pickData}
              src={thumbnailTextile}
            />
            <CatThumbnail
              title={this.i18n.books}
              keyword="book"
              pickData={pickData}
              src={thumbnailVideo}
            />
          </div>
          <div className="flex w-100-ns w-80 category-container flex-column items-center justify-center">
            <p className="background-line w-100 tc ml0 mr0">
              <span>{this.i18n['or_play_them_all']}</span>
            </p>
            <div className="flex w-100 category-container flex-wrap flex-nowrap-ns items-center justify-center">
              <CatThumbnail
                title={this.i18n.all}
                keyword="all"
                pickData={pickData}
                src={thumbnailAll}
              />
            </div>
          </div>
        </motion.div>
      </div>
    );
  }
}

export default Intro;
